import React from 'react'
import { Box } from '@chakra-ui/react'

type UnseenIndicatorDotProps = {
  /** Wrapped so the dot can be positioned against it. */
  children: React.ReactNode
  show: boolean
  /** Chakra colour token for the dot itself. */
  colorToken?: string
  'data-testid'?: string
}

/**
 * Small status dot pinned to the top-right of an icon, used to mark "there is something new
 * here" on a navigation item.
 *
 * The dot is `aria-hidden`: it carries no information of its own, and the item that renders
 * it is expected to state the count in its own accessible name. Announcing the dot as well
 * would read as a stray element between the label and the count.
 */
export function UnseenIndicatorDot({
  children,
  show,
  colorToken = 'orange.solid',
  'data-testid': dataTestId,
}: UnseenIndicatorDotProps): React.ReactElement {
  return (
    <Box position="relative" display="inline-flex">
      {children}

      {show && (
        <Box
          data-testid={dataTestId}
          aria-hidden="true"
          position="absolute"
          top="-2px"
          right="-2px"
          width="12px"
          height="12px"
          borderRadius="full"
          bg={colorToken}
          border="2px solid"
          borderColor="bg"
        />
      )}
    </Box>
  )
}
